/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 *   Sets parameters for audio notification of banners ie. make noise or don't make
 *   noise.  The setting is stored locally.
 */

var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

module.exports = Model({
	name: "bannernotice",

	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	play_sound: play_sound,
	start_repeating: start_repeating,
	stop_repeating: stop_repeating,

	_repeating: null
});

var PLAY_INTERVAL = 10 * 1000; // 10 seconds

function init() {
	return AsyncStorage.getItem("banner_notice").then(function (banner_notice) {
		var enabled = banner_notice !== "false";
		this.push(enabled);
	}.bind(this));

}

function uninit() {
	this.stop_repeating();
}

function listeners() {
	return {
		"banner:updated": handle_banner_updated,
		"mqtt:$/banner/new": handle_new_banner,
	};
}

function triggers() {
	return {
		"set": set_notice
	};
}

function set_notice(data) {
	var enabled = data.enabled;
	AsyncStorage.setItem("banner_notice", enabled.toString());
	this.push(enabled);
	this.emit("usermetrics:trigger:track", `toggle banner sound to ${enabled ? "on" : "off"} in own account menu`);
}

function handle_banner_updated(banners) {
	if (!this.data) return;
	var wandering = has_wandering(banners);

	if (this._repeating && !wandering) this.stop_repeating();
	if (!this._repeating && wandering) this.start_repeating();
}

function handle_new_banner() {
	if (!this.data) return;
	this.play_sound();
}

function stop_repeating() {
	var timer = this._repeating;
	if (!timer) return;
	clearInterval(timer);
	this._repeating = null;
}

function start_repeating() {
	if (this._repeating) return;
	this._repeating = setInterval(play_sound.bind(this), PLAY_INTERVAL);
}

function play_sound() {
	this.emit("sounds:trigger:play", {
		sound: "alert",
		volume: 1
	});
}

function has_wandering(banners) {
	return banners.some(function (banner) {
		return banner.content.wandering === 1;
	});
}
